import { SelectData } from '@occc-app/design-system';
import { AudienceBroadcastMessageStatus } from '@occc/graphql';

import { MessageTypeEnum } from './messaging-campaigns-filter.schema';
import { MessageType } from './messaging-campaigns-filter.types';

import { titleByStatus } from '../../messaging-campaigns-list.constants';

export const MESSAGE_TYPE_OPTIONS: SelectData<MessageType>[] = [
  { value: MessageTypeEnum.enum.BOTH, label: 'SMS and Push' },
  { value: MessageTypeEnum.enum.SMS, label: 'SMS' },
  { value: MessageTypeEnum.enum.PUSH, label: 'Push' },
];

export const STATUS_OPTIONS: SelectData<AudienceBroadcastMessageStatus | ''>[] = [
  { value: '', label: 'View All' },
  ...Object.keys(titleByStatus).map((value) => ({
    value: value as AudienceBroadcastMessageStatus,
    label: titleByStatus[value as AudienceBroadcastMessageStatus],
  })),
];
